<div class="table-body-wrapper" style="position: relative">
  <!-- Tabs -->
  <div class="tabs-wrapper" *ngIf="shouldShowEditModeTabs()">
    <div class="custom-tab-container">
      <div class="tab-group">
        <div
          class="custom-tab"
          [class.active]="!isEditMode"
          (click)="exitEdit()"
        >
          View
        </div>
        <div class="tab-description">{{ data.viewNote }}</div>
      </div>

      <div class="tab-group">
        <div
          class="custom-tab"
          [class.active]="isEditMode"
          (click)="enterEdit()"
        >
          Edit
        </div>
        <div class="tab-description">{{ data.editNote }}</div>
      </div>
    </div>
  </div>
</div>

<div
  style="display: flex; justify-content: flex-end; gap: 4px; margin-bottom: 4px;align-items: center;"
>
  <div *ngIf="note">
    Note:<strong class="rednote">{{ note }}</strong>
  </div>
  <button
    *ngIf="isEditMode && shouldShowTopSaveButton()"
    matTooltip="Save"
    (click)="save()"
    class="btn"
    [disabled]="!changed"
    style="cursor: pointer"
  >
    Save
  </button>
</div>

<!-- Toolbar -->
<div class="table-toolbar">
  <div *ngIf="data.costFilter" class="budget-item">
    <mat-checkbox
      [checked]="selectedFilters.includes('=0')"
      (change)="selectFilter('=0', $event.checked)"
    >
     <label> Project cost = 0 or NULL ({{ fullData?.projectsWithZeroCost || 0 }})</label>
    </mat-checkbox>

    <mat-checkbox
      [checked]="selectedFilters.includes('<50K')"
      (change)="selectFilter('<50K', $event.checked)"
    >
     <label> Project cost < $50k ({{ fullData?.projectsLessThan50k || 0 }})</label>
    </mat-checkbox>

    <mat-checkbox
      [checked]="selectedFilters.includes('>50K')"
      (change)="selectFilter('>50K', $event.checked)"
    >
      <label>Project cost > $50k ({{ fullData?.projectsGreaterThan50k || 0 }})</label>
    </mat-checkbox>
  </div>

  <span class="spacer"></span>
  <div class="budget-item" *ngIf="data.totalBudget">
    <label>Total Budget for Selected Projects ($M)</label>
    <div class="budget-box">{{ totalBudget || 0 }}</div>
  </div>
  <div class="budget-item" *ngIf="data.availableBudget">
    <label>Available Budget ($M)</label>
    <input
      class="budget-box"
      type="number"
      step="1"
      (input)="onBudgetInput($event)"
      [value]="availableBudget"
      (wheel)="$event.preventDefault()"
    />
</div>
  <div class="tool-box">
    <mat-icon
      *ngIf="isEditMode && data.buttons?.includes('validation')"
      class="toolbar-item"
      matTooltip="Show Only Invalid Rows"
      (click)="toggleInvalidFilter()"
      [ngClass]="{ 'active-filter': showInvalidOnly }"
      style="cursor: pointer"
    >
      error_outline
    </mat-icon>
    <mat-icon
      *ngIf="data.downloadDataUrl && data.buttons?.includes('download')"
      class="toolbar-item"
      matTooltip="Download Data"
      (click)="downloadData()"
      style="cursor: pointer; width: 28px"
      >cloud_download</mat-icon
    >
    <mat-icon
      *ngIf="data.downloadExcelDataUrl && data.buttons?.includes('downloadExcel')"
      class="toolbar-item"
      matTooltip="Download Excel"
      (click)="downloadExcel()"
      style="cursor: pointer; width: 28px"
      >download_for_offline</mat-icon
    >
    <mat-icon
      *ngIf="canShowEditAccessAction() && data.buttons?.includes('editAccess') && data.editAccessAction"
      class="toolbar-item edit-access-action"
      [class.disabled-action]="isLoading"
      [matTooltip]="getEditAccessTooltip()"
      (click)="enableEditAccess()"
      style="cursor: pointer; width: 28px"
      >{{ getEditAccessIcon() }}</mat-icon
    >
    <!-- <mat-icon
        *ngIf="data.upload && isEditMode"
        class="toolbar-item"
        matTooltip="Download Sample CSV"
        (click)="downloadCSV()"
        style="cursor: pointer"
        >download</mat-icon
      > -->
    <mat-icon
      *ngIf="isEditMode && data.buttons?.includes('upload')"
      class="toolbar-item"
      matTooltip="Upload File in CSV Format"
      (click)="upload()"
      style="cursor: pointer"
      >upload</mat-icon
    >
    <mat-icon
      *ngIf="isEditMode && data.buttons?.includes('uploadExcel')"
      class="toolbar-item"
      matTooltip="Upload Excel"
      (click)="uploadExcel()"
      style="cursor: pointer"
      >drive_folder_upload</mat-icon
    >

    <mat-icon
      *ngIf="isEditMode && data.buttons?.includes('add')"
      class="toolbar-item"
      matTooltip="Add Row"
      (click)="addRow()"
      style="cursor: pointer"
      >add</mat-icon
    >

    <!-- <mat-icon
        *ngIf="isEditMode"
        class="toolbar-item"
        matTooltip="Save"
        (click)="save()"
        style="cursor: pointer"
        >save</mat-icon
      > -->

    <mat-icon
      *ngIf="isEditMode && data.buttons?.includes('refresh')"
      class="toolbar-item"
      matTooltip="Refresh"
      (click)="refresh()"
      style="cursor: pointer"
      >refresh</mat-icon
    >
  </div>
</div>

<!-- Data Table -->
<ngx-datatable
  #table
  class="material"
  [rows]="rows"
  [rowIdentity]="rowIdentity"
  [columnMode]="columnMode"
  [headerHeight]="30"
  [footerHeight]="24"
  [rowHeight]="tableRowHeight"
  [scrollbarH]="true"
  [scrollbarV]="true"
  [virtualization]="true"
  [rowClass]="getRowClass"
  [externalSorting]="true"
  (sort)="onSort($event)"
  [count]="rows.length"
>
  <ngx-datatable-footer *ngIf="data?.showRecordCount">
    <ng-template ngx-datatable-footer-template>
      <div class="record-count-footer">
        <span class="record-count-text">{{ rows.length || 0 }} total</span>
      </div>
    </ng-template>
  </ngx-datatable-footer>

  <!-- S.No Column (row numbering) -->
  <ngx-datatable-column
    name="S.No"
    [width]="100"
    [sortable]="false"
    [frozenLeft]="true"
    headerClass="sno-sticky-column"
    cellClass="sno-sticky-column"
  >
    <ng-template ngx-datatable-header-template>
      <div class="sno-cell-content sno-header-content">
        <span class="sno-label">S.No</span>
        <mat-checkbox
          class="sno-select-all-checkbox"
          [checked]="isAllSelected()"
          [indeterminate]="isIndeterminate()"
          (change)="toggleSelectAll($event.checked)"
        ></mat-checkbox>
      </div>
    </ng-template>

    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-row="row"
    >
      <div class="sno-cell-content sno-row-content">
        <div class="sno-index">{{ rowIndex + 1 }}</div>
        <mat-checkbox
          class="sno-row-checkbox"
          (click)="$event.stopPropagation()"
          (change)="toggleRow(row)"
          [checked]="isSelected(row)"
        ></mat-checkbox>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <!-- Dynamic Columns (no numbering for rows) -->
  <ng-container
    *ngFor="let column of renderedColumns; let columnIndex = index; trackBy: trackByHeader"
  >
    <ngx-datatable-column
      [name]="column.name"
      [prop]="column.prop"
      [width]="column.width || getDefaultColumnWidth()"
      [sortable]="column.sortable !== false"
      [frozenLeft]="isColumnFrozen(column, columnIndex)"
      [frozenRight]="isEditMode && isDeleteColumn(column)"
      [headerClass]="getHeaderClass(column)"
      [cellClass]="isDeleteColumn(column) ? 'action-column-cell' : getCellClass(column)"
    >
      <ng-template ngx-datatable-header-template let-col="column">
        <ng-container *ngIf="isDeleteColumn(column); else normalHeader">
          <div
            style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;"
          >
            <span style="font-weight: 600;">Delete</span>
          </div>
        </ng-container>

        <ng-template #normalHeader>
          <div class="table-header-content">
            <div
              class="table-header-label"
              [class.sortable-label]="column.sortable !== false"
              [title]="column.name"
              (click)="sortColumn(column, $event)"
            >
              {{ column.name }}
              <span *ngIf="hasMandatoryRule(column)"> **</span>
            </div>
            <div class="header-actions">
              <mat-icon
                *ngIf="columnIndex < 4"
                class="header-action-icon pin-icon"
                [ngClass]="{ 'pin-icon-active': isColumnPinned(column) }"
                matTooltip="Pin columns to this point"
                matTooltipShowDelay="300"
                (click)="onPinColumn(column, $event)"
              >
                push_pin
              </mat-icon>

              <!-- Show total if enabled -->
              <div
                *ngIf="column.showTotal && column.type === 'number'"
                style="display: flex; align-items: center; margin-left: 8px"
              >
                &Sigma;:
                <div class="budget-box">
                  {{ getColumnTotal(column.prop) | number : "1.0-4" }}
                </div>
              </div>

              <mat-icon
                *ngIf="shouldShowHeaderInfo(column) && !shouldShowHeaderImageTooltip(column)"
                class="header-action-icon header-info-icon"
                [matTooltip]="getHeaderTooltipText(column)"
                matTooltipShowDelay="300"
              >
                info
              </mat-icon>
              <mat-icon
                *ngIf="shouldShowHeaderImageTooltip(column)"
                class="header-action-icon header-info-icon"
                [mtxTooltip]="imageTooltip"
                mtxTooltipPosition="left"
                matTooltipShowDelay="300"
              >
                info
              </mat-icon>
              <ng-template #imageTooltip>
                <img
                  [src]="column.tooltipUrl"
                  [alt]="column.name || 'Tooltip'"
                  [style.width]="column.tooltipImage === 'parameterTooltip' ? '20vw' : '50vw'"
                  [style.height]="column.tooltipImage === 'parameterTooltip' ? '7vh' : '50vh'"
                />
              </ng-template>

              <!-------------- filter -------------->
              <div class="header-action-menu">
                <mat-icon
                  #trigger="matMenuTrigger"
                  (click)="openFilter(column, trigger, $event)"
                  [matMenuTriggerFor]="filterMenu"
                  class="header-action-icon icon"
                  [ngClass]="{
                    'active-filter': columnFilters[column.prop]?.length > 0
                  }"
                  >filter_list</mat-icon
                >

                <mat-menu #filterMenu="matMenu" style="background-color: #fff">
                  <div (click)="$event.stopPropagation()">
                    <!-- Header bar with close icon -->
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 2px 4px;
                        font-weight: 600;
                        background-color: #fff;
                      "
                    >
                      <span>{{ activeColumn?.name }}</span>
                      <mat-icon
                        style="font-size: 18px; cursor: pointer"
                        (click)="closeMenu($event)"
                      >
                        close
                      </mat-icon>
                    </div>

                    <!-- Search -->
                    <input
                      style="margin: 4px; width: 96%"
                      placeholder="Search..."
                      (click)="$event.stopPropagation()"
                      [(ngModel)]="searchText"
                      (input)="filterSearch(activeColumn?.prop, $event)"
                    />

                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      [checked]="areAllSelected(activeColumn?.prop)"
                      [indeterminate]="selectPerOne(activeColumn?.prop)"
                      (change)="toggleAll(activeColumn?.prop, $event.checked)"
                      style="margin-bottom: 8px; font-weight: 600"
                    >
                      Select All
                    </mat-checkbox>

                    <!-- Checkbox list -->
                    <div
                      style="
                        max-height: 300px;
                        overflow: auto;
                        display: flex;
                        flex-direction: column;
                        background-color: #fff;
                      "
                    >
                      <mat-checkbox
                        *ngFor="let value of getUniqueValues(activeColumn?.prop)"
                        (click)="$event.stopPropagation()"
                        [checked]="isValueChecked(activeColumn?.prop, value)"
                        (change)="
                          onFilterChange(activeColumn?.prop, value, $event.checked)
                        "
                        style="margin-bottom: 4px"
                      >
                        {{ value || "(Blank)" }}
                      </mat-checkbox>
                    </div>

                    <!-- Footer -->
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        padding: 8px;
                        border-top: 1px solid #ddd;
                      "
                    >
                      <button
                        mat-stroked-button
                        style="flex: 1; margin-right: 6px"
                        class="reset"
                        (click)="
                          clearFilter(activeColumn?.prop); $event.stopPropagation()
                        "
                      >
                        Clear
                      </button>
                      <button
                        mat-stroked-button
                        color="primary"
                        class="btn"
                        style="flex: 1; margin-right: 6px"
                        (click)="applyFilters('close')"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </mat-menu>
              </div>

              <mat-icon
                *ngIf="column.sortable !== false"
                class="header-action-icon sort-icon"
                [ngClass]="{ 'active-sort': isColumnSorted(column) }"
                [matTooltip]="getSortTooltipText(column)"
                matTooltipShowDelay="300"
                (click)="sortColumn(column, $event)"
              >
                {{ getSortIcon(column) }}
              </mat-icon>
            </div>
          </div>
        </ng-template>
      </ng-template>

      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-rowIndex="rowIndex"
      >
        <ng-container *ngIf="isDeleteColumn(column); else normalCellContent">
          <div class="action-cell-center">
            <button
              mat-icon-button
              color="warn"
              [disabled]="isDeleteDisabled(row, rowIndex)"
              [matTooltip]="getDeleteTooltip(row, rowIndex)"
              (click)="deleteRow(rowIndex)"
            >
              <mat-icon [ngClass]="{ 'delete-icon-crossed': row.is_deleted }">
                {{ row.is_deleted ? 'delete_off' : 'delete' }}
              </mat-icon>
            </button>
          </div>
        </ng-container>

        <ng-template #normalCellContent>
        <!-- Editable mode -->
        <ng-container
          *ngIf="
            isCellEditableForRow(column, row, rowIndex);
            else readOnly
          "
        >
          <!-- Dropdown -->
          <ng-container *ngIf="column.type === 'dropdown'; else textInput">
            <!-- MULTISELECT -->
            <div
              class="multi-select-cell"
              [ngClass]="{
                'invalid-cell':
                  column.highlightInvalid &&
                  ((isColumnMandatoryForRow(column, row) && isBlank(rows[rowIndex][column.prop])) ||
                    hasUnmatchedValues(
                      rows[rowIndex][column.prop],
                      column.list
                    ))
              }"
            >
              <mat-form-field
                appearance="outline"
                *ngIf="column.isMultiSelect; else normalSelect"
                class="cell-input"
              >
                <mat-select
                  [multiple]="true"
                  panelClass="cell-dropdown-panel"
                  [compareWith]="compareDropdownValues"
                  [(ngModel)]="rows[rowIndex][column.prop]"
                  (openedChange)="
                    onDropdownOpenedChange(
                      $event,
                      rowIndex,
                      column.prop,
                      column
                    )
                  "
                  [matTooltip]="getMultiSelectTooltip(rows[rowIndex][column.prop])"
                  [matTooltipDisabled]="
                    !getMultiSelectTooltip(rows[rowIndex][column.prop])
                  "
                  matTooltipClass="multi-select-tooltip"
                  matTooltipShowDelay="300"
                  (selectionChange)="
                    updateCell(rowIndex, column.prop, $event.value)
                  "
                >
                  <mat-select-trigger>
                    {{ formatCellValue(rows[rowIndex][column.prop]) }}
                  </mat-select-trigger>

                  <mat-option
                    *ngIf="shouldEnableDropdownSearch(column)"
                    class="search-option"
                    (onSelectionChange)="onSearchOptionSelection($event)"
                  >
                    <input
                      class="dropdown-search-input"
                      type="text"
                      placeholder="Search..."
                      autocomplete="off"
                      [ngModel]="getDropdownSearchText(rowIndex, column.prop)"
                      (ngModelChange)="onDropdownSearchInput(rowIndex, column.prop, $event)"
                      (mousedown)="$event.stopPropagation()"
                      (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      (keyup)="$event.stopPropagation()"
                    />
                  </mat-option>

                  <!-- Valid options -->
                  <mat-option
                    *ngFor="let option of getDropdownOptionsForDisplay(column, rowIndex); trackBy: trackByDropdownOption"
                    [value]="option.value ?? option"
                    [class.hidden-dropdown-option]="
                      !isDropdownOptionVisible(option, column, rowIndex)
                    "
                  >
                    {{ option.viewValue ? option.viewValue : option }}
                  </mat-option>

                  <!-- Unmatched (non-blank) options -->
                  <mat-option
                    *ngFor="
                      let unmatched of getUnmatchedValues(
                        rows[rowIndex][column.prop],
                        column.list
                      )
                    "
                    [value]="unmatched"
                    class="unmatched-option"
                  >
                    {{ unmatched }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- SINGLE SELECT -->
            <ng-template #normalSelect>
              <div
                class="single-select-cell"
                [ngClass]="{
                  'invalid-cell':
                    column.highlightInvalid &&
                    ((isColumnMandatoryForRow(column, row) &&
                      isBlank(rows[rowIndex][column.prop])) ||
                      hasUnmatchedValues(
                        rows[rowIndex][column.prop],
                        column.list
                      ))
                }"
              >
                <mat-form-field appearance="outline" class="cell-input">
                  <mat-select
                    #cellSelect
                    [compareWith]="compareDropdownValues"
                    [panelClass]="
                      isPlanningYearTarget(column)
                        ? ['cell-dropdown-panel', 'planning-year-panel']
                        : 'cell-dropdown-panel'
                    "
                    [(ngModel)]="rows[rowIndex][column.prop]"
                    [matTooltip]="getPlanningYearTooltip(rowIndex, column)"
                    [matTooltipDisabled]="!getPlanningYearTooltip(rowIndex, column)"
                    matTooltipPosition="above"
                    matTooltipShowDelay="300"
                    (openedChange)="
                      onDropdownOpenedChange(
                        $event,
                        rowIndex,
                        column.prop,
                        column
                      )
                    "
                    (selectionChange)="
                      updateCell(rowIndex, column.prop, $event.value)
                    "
                  >
                    <mat-select-trigger *ngIf="isPlanningYearTarget(column)">
                      {{ getPlanningDropdownDisplay(rowIndex, column) }}
                    </mat-select-trigger>

                    <mat-option
                      *ngIf="shouldEnableDropdownSearch(column)"
                      class="search-option"
                      (onSelectionChange)="onSearchOptionSelection($event)"
                    >
                      <input
                        class="dropdown-search-input"
                        type="text"
                        placeholder="Search..."
                        autocomplete="off"
                        [ngModel]="getDropdownSearchText(rowIndex, column.prop)"
                        (ngModelChange)="onDropdownSearchInput(rowIndex, column.prop, $event)"
                        (mousedown)="$event.stopPropagation()"
                        (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()"
                        (keyup)="$event.stopPropagation()"
                      />
                    </mat-option>

                    <!-- Valid options -->
                    <ng-container
                      *ngFor="let option of getDropdownOptionsForDisplay(column, rowIndex); trackBy: trackByDropdownOption"
                    >
                      <mat-option
                        [value]="option.value ? option.value : option"
                        (mouseenter)="onAopOptionHover(rowIndex, column, option)"
                        [class.hidden-dropdown-option]="
                          !isDropdownOptionVisible(option, column, rowIndex)
                        "
                      >
                        {{ option.viewValue ? option.viewValue : option }}
                        <mat-icon
                          *ngIf="isPlanningYearOption(column, option)"
                          class="planning-year-chevron"
                        >chevron_right</mat-icon>
                      </mat-option>

                      <div
                        *ngIf="shouldShowPlanningYears(rowIndex, column, option)"
                        class="planning-year-options"
                        (mouseenter)="keepPlanningYearFlyoutOpen(rowIndex, column)"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="planning-year-title">Active Year</div>
                        <div *ngIf="planningYearLoading" class="planning-year-message">Loading...</div>
                        <button
                          *ngFor="let year of planningYearOptions"
                          type="button"
                          class="planning-year-option"
                          [class.planning-year-option-selected]="
                            isPlanningYearSelected(rowIndex, year)
                          "
                          [attr.aria-selected]="isPlanningYearSelected(rowIndex, year)"
                          (click)="
                            selectPlanningYear(
                              $event,
                              rowIndex,
                              column,
                              year,
                              cellSelect
                            )
                          "
                        >
                          <span>{{ year }}</span>
                          <mat-icon *ngIf="isPlanningYearSelected(rowIndex, year)">check</mat-icon>
                        </button>
                        <div *ngIf="planningYearError" class="planning-year-message">{{ planningYearError }}</div>
                      </div>
                    </ng-container>

                    <!-- Invalid value (only if highlightInvalid is true) -->
                    <mat-option
                      *ngIf="
                        column.highlightInvalid &&
                        !isBlank(rows[rowIndex][column.prop]) &&
                        !isValueInList(rows[rowIndex][column.prop], column.list)
                      "
                      [value]="rows[rowIndex][column.prop]"
                      class="unmatched-option"
                    >
                      {{ rows[rowIndex][column.prop] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-template>
          </ng-container>

          <ng-template #textInput>
            <div
              class="comment-editor-host"
              [class.comment-editor-enabled]="isCommentTooltipColumn(column)"
              [class.comment-editor-active]="
                isCommentTooltipColumn(column) && isCommentEditorActive(row)
              "
              (mouseenter)="isCommentTooltipColumn(column) && onCommentEditorMouseEnter(row)"
              (mouseleave)="isCommentTooltipColumn(column) && onCommentEditorMouseLeave(row)"
              (focusin)="isCommentTooltipColumn(column) && onCommentEditorFocusIn(row)"
              (focusout)="
                isCommentTooltipColumn(column) &&
                  onCommentEditorFocusOut($event, row)
              "
            >
              <input
                class="cell-input"
                [ngClass]="{
                  'invalid-cell-input':
                    column.highlightInvalid &&
                    isColumnMandatoryForRow(column, row) &&
                    isBlank(rows[rowIndex][column.prop]),
                  'comment-inline-input': isCommentTooltipColumn(column)
                }"
                [type]="column.type || 'text'"
                [step]="getNumberInputStep(column)"
                [attr.min]="getDateInputMin(row, column)"
                [attr.max]="getDateInputMax(row, column)"
                [attr.maxlength]="column.length || null"
                [ngModel]="rows[rowIndex][column.prop]"
                (input)="
                  onInputValueChange($event, rowIndex, column.prop, column.type)
                "
                (wheel)="$event.preventDefault()"
              />
              <div
                *ngIf="isCommentTooltipColumn(column)"
                class="comment-edit-popover"
              >
                <textarea
                  class="comment-edit-textarea"
                  [attr.maxlength]="column.length || null"
                  [ngModel]="rows[rowIndex][column.prop]"
                  (ngModelChange)="
                    onCellValueChange(rowIndex, column.prop, column.type, $event)
                  "
                ></textarea>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <!-- Read-only -->
        <ng-template #readOnly>
          <span
            [ngClass]="{
              'deleted-cell': row.is_deleted,
              'highlight-green': getHighlightGreen(row, column),
              'highlight-red': getHighlightRed(row, column)
            }"
            [style.display]="isSingleLineCell(column, row, rowIndex) ? 'block' : null"
            [style.overflow]="isSingleLineCell(column, row, rowIndex) ? 'hidden' : null"
            [style.text-overflow]="isSingleLineCell(column, row, rowIndex) ? 'ellipsis' : null"
            [style.white-space]="isSingleLineCell(column, row, rowIndex) ? 'nowrap' : null"
            [style.width]="isSingleLineCell(column, row, rowIndex) ? '100%' : null"
            [matTooltip]="
              isSingleLineCell(column, row, rowIndex)
                ? getCommentTooltip(row[column.prop])
                : isCommentTooltipColumn(column)
                ? getCommentTooltip(row[column.prop])
                : column.isMultiSelect
                  ? getMultiSelectTooltip(row[column.prop])
                  : ''
            "
            [matTooltipDisabled]="
              isSingleLineCell(column, row, rowIndex)
                ? !getCommentTooltip(row[column.prop])
                : isCommentTooltipColumn(column)
                ? !getCommentTooltip(row[column.prop])
                : !column.isMultiSelect || !getMultiSelectTooltip(row[column.prop])
            "
            matTooltipClass="multi-select-tooltip"
            matTooltipShowDelay="300"
          >
            <!-- Date formatting -->
            <ng-container *ngIf="column.type === 'date'; else checkNumber">
              {{ formatDateCellValue(row[column.prop], column) }}
            </ng-container>

            <!-- Number formatting -->
            <ng-template #checkNumber>
              <ng-container *ngIf="column.type === 'number'; else normalCell">
                {{
                  Number.isFinite(+row[column.prop])
                    ? (+row[column.prop] | number : getNumberDisplayFormat(column.prop))
                    : row[column.prop]
                }}
              </ng-container>
            </ng-template>

            <!-- Default (text or others) -->
            <ng-template #normalCell>
              {{ formatCellValue(row[column.prop]) }}
            </ng-template>
          </span>
        </ng-template>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>
  </ng-container>

  <ngx-datatable-column
    *ngIf="shouldShowRowSaveColumn()"
    [name]="getRowSaveColumnLabel()"
    [width]="getRowSaveColumnWidth()"
    [sortable]="false"
    [frozenRight]="true"
    [headerClass]="'align-center'"
    [cellClass]="'action-column-cell align-center'"
  >
    <ng-template ngx-datatable-header-template>
      <div style="font-weight: 600;">{{ getRowSaveColumnLabel() }}</div>
    </ng-template>

    <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
      <button
        type="button"
        class="btn"
        style="height: 30px; padding: 2px 8px; min-width: 0; white-space: nowrap;"
        [style.width.px]="getRowSaveButtonWidth()"
        [disabled]="isRowSaveDisabled(row, rowIndex)"
        [matTooltip]="getRowSaveTooltip(row, rowIndex)"
        (click)="saveRow(row)"
      >
        {{ getRowSaveButtonLabel() }}
      </button>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    *ngIf="shouldShowRowActions()"
    name="Options"
    [width]="getRowActionColumnWidth()"
    [sortable]="false"
    [frozenRight]="true"
    [headerClass]="'align-center'"
    [cellClass]="'action-column-cell align-center'"
  >
    <ng-template ngx-datatable-header-template>
      <div style="font-weight: 600;">{{ getRowActionColumnLabel() }}</div>
    </ng-template>

    <ng-template
      ngx-datatable-cell-template
      let-row="row"
      let-rowIndex="rowIndex"
    >
      <div style="display: flex; align-items: center; justify-content: center; gap: 4px; width: 100%; min-width: 0;">
        <button
          *ngFor="let action of rowActions"
          type="button"
          class="btn"
          [style]="getRowActionButtonStyle()"
          [disabled]="isRowActionDisabled(action, row)"
          [matTooltip]="action.tooltip || action.label"
          (click)="onRowAction(action, row, rowIndex)"
        >
          {{ action.label }}
        </button>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    *ngIf="shouldShowTrailingDeleteColumn()"
    name="Delete"
    [width]="80"
    [sortable]="false"
    [frozenRight]="true"
    [headerClass]="'align-center'"
    [cellClass]="'action-column-cell align-center'"
  >
    <ng-template ngx-datatable-header-template>
      <div style="font-weight: 600;">Delete</div>
    </ng-template>

    <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
      <div class="action-cell-center">
        <button
          mat-icon-button
          color="warn"
          [disabled]="isDeleteDisabled(row, rowIndex)"
          [matTooltip]="getDeleteTooltip(row, rowIndex)"
          (click)="deleteRow(rowIndex)"
        >
          <mat-icon [ngClass]="{ 'delete-icon-crossed': row.is_deleted }">
            {{ row.is_deleted ? 'delete_off' : 'delete' }}
          </mat-icon>
        </button>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    *ngIf="shouldShowAuditHistoryColumn()"
    name="Audit History"
    [width]="120"
    [sortable]="false"
    [frozenRight]="true"
    [headerClass]="'align-center'"
    [cellClass]="'action-column-cell align-center'"
  >
    <ng-template ngx-datatable-header-template>
      <div
        style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;"
      >
        <span style="font-weight: 600;">Audit History</span>
      </div>
    </ng-template>

    <ng-template ngx-datatable-cell-template let-row="row">
      <button
        mat-icon-button
        matTooltip="View audit history"
        (click)="openAuditHistory(row)"
      >
        <img
          [src]="auditHistoryIcon"
          alt="Audit History"
          class="audit-history-icon"
        />
      </button>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>

<div class="spinner-overlay" *ngIf="isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    diameter="40"
  ></mat-progress-spinner>
</div>
<div class="note">
  <strong>Notes:</strong>
  <ul style="margin: 4px 0 0 16px; padding: 0">
    <li *ngFor="let item of data.note">
      {{ item }}
    </li>
  </ul>
</div>
